'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require('../../lib/Select');

var _Select2 = _interopRequireDefault(_Select);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'field': 'Select__field___3wlin',
  'sizeLarge': 'Select__sizeLarge___3FsSh',
  'select': 'Select__select___Uuaqu',
  'heightLarge': 'Select__heightLarge___utsX-',
  'heightDefault': 'Select__heightDefault___3Oyz0',
  'placeholderWithoutValue': 'Select__placeholderWithoutValue___qbTTE',
  'sizeSmall': 'Select__sizeSmall___23w5-',
  'heightSmall': 'Select__heightSmall___ZMTIb',
  'withPlaceholder': 'Select__withPlaceholder___bxjO1',
  'placeholder': 'Select__placeholder___2m6Hv',
  'withoutAnimatedPlaceholder': 'Select__withoutAnimatedPlaceholder___UCR95',
  'sizeMedium': 'Select__sizeMedium___33BFk',
  'heightMedium': 'Select__heightMedium___1ZymC',
  'disabled': 'Select__disabled___1WPa9',
  'valid': 'Select__valid___1yyDb',
  'error': 'Select__error___1jTWl',
  'inputErrorMessage': 'Select__inputErrorMessage___2Pp2Q',
  'multiSelectValueContainer': 'Select__multiSelectValueContainer___HjO_F',
  'multiSelectLabel': 'Select__multiSelectLabel___HFebX',
  'multiSelectCloseContainer': 'Select__multiSelectCloseContainer___hJCVY',
  'multiSelectClose': 'Select__multiSelectClose___2H5-M'
};

var DefaultSelect = (0, _mergeThemeHoc2.default)(style)(_Select2.default);
DefaultSelect.displayName = 'DefaultSelect';
exports.default = DefaultSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Select/index.js
// module id = ./node_modules/dibs-elements/dist/Select/index.js
// module chunks = 4